import isVueStandalone from '@shared/services/api/environmentHelper.js'

export function apiPathStart(){
  return isVueStandalone() ? 'https://localhost:44362' : '';
}

export function rootUrl(){
  var root = window.location.protocol + "//" + window.location.host + "/"
  return root
}